import { useCallback, useMemo } from 'react'
import { requireNotNull } from '@shared/pipes/require-not-null'

import { SignConsentDocumentId } from '../../../api-types'
import { BrokerSignScreenStepProps } from '../../../shared/broker/types'

import { View } from './view'

export const BrokerSignAgreementConsent = (ownProps: BrokerSignScreenStepProps) => {
	const getDocumentById = useCallback(
		(id: SignConsentDocumentId) => {
			return requireNotNull(
				ownProps.documents.find((doc) => doc.id === id),
				`[BrokerSignAgreementConsent] document by id: ${id} not found`
			)
		},
		[ownProps.documents]
	)

	const documentConsent = useMemo(
		() => getDocumentById(SignConsentDocumentId.UNIFIED_PERSONALIZED_CONSENT),
		[getDocumentById]
	)

	return View({
		documentName: documentConsent.name,
		onNextButtonClick: ownProps.onNext,
	})
}
